module.exports = __webpack_public_path__ + "static/media/apple-store-it.0a6a96b9.svg";